import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { allValidations } from "../../utils/formValidations";
import { HOST } from "../../constants";
import { showFormErrors } from "../../utils/commonFunctions";
import { addOurWork, addProduct, deleteProduct, fetchOurWorkDetails, updateProduct, updateWork } from "../../redux/actions/ourWorkAction";
import { confirmPopup } from "primereact/confirmpopup";

export default function OurWorkContainer() {
    const dispatch = useDispatch();
    const history = useHistory();

    const { ourWorkDetails } = useSelector((state) => state.work);
    let ignoreFields = [];
    let defualtIgnoreField = "products";

    const { id } = useParams();
    const [formType, setFormType] = useState("EDIT");
    const [showAddProductDialog, setShowAddProductDialog] = useState(false);

    const [data, setData] = useState({
        service: "",
        name: "",
        // description: "",
        hasBeforeAfterImages: true,
        beforeImage: "",
        afterImage: "",
        singleImage: "",
        products: [],
    });

    const [product, setProduct] = useState({
        _id: null,
        title: "",
        subTitle: "",
        ourWork: id,
        // description: "",
        image: "",
        url: "",
    });

    useEffect(() => {
        if (id) {
            dispatch(fetchOurWorkDetails(id));
        }
    }, [id, dispatch]);

    const [loading, setLoading] = useState(false);

    const handleChange = ({ name, value }) => {
        if (name === "hasBeforeAfterImages" && value) {
            ignoreFields = ["singleImage"];
        } else if (name === "hasBeforeAfterImages" && !value) {
            ignoreFields = ["beforeImage", "afterImage"];
        }

        let formErrors = {};
        formErrors = allValidations(name, value, data, [...ignoreFields, defualtIgnoreField]);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const addWork = () => {
        if (data.hasBeforeAfterImages) {
            ignoreFields = ["singleImage"];
        } else {
            ignoreFields = ["beforeImage", "afterImage"];
        }

        const imageFields = ["beforeImage", "afterImage", "singleImage"];
        // Create a copy of data to avoid directly mutating the state
        const updatedData = { ...data };

        // Update image fields to use value[0]
        imageFields.forEach((field) => {
            if (Array.isArray(updatedData[field]) && updatedData[field].length > 0) {
                updatedData[field] = updatedData[field][0];
            }
        });

        if (showFormErrors(updatedData, setData, [...ignoreFields, defualtIgnoreField])) {
            if (id) {
                dispatch(updateWork(id, updatedData, history));
            } else {
                dispatch(addOurWork(updatedData, history));
            }
        }

    };

    useEffect(() => {
        if (id) {
            delete ourWorkDetails.description
            setData({
                ...ourWorkDetails,
                service: ourWorkDetails?.service?._id,
                hasBeforeAfterImages: ourWorkDetails?.singleImage ? false : true,
            });
        }
    }, [id, ourWorkDetails]);

    const editProduct = (product) => {
        setProduct({
            _id: product._id,
            title: product?.title,
            subTitle: product?.subTitle,
            ourWork: id,
            // description: product?.description,
            image: product?.image,
            url: product?.url,
        });
        setShowAddProductDialog(true);
    };

    const handleProductChange = ({ name, value }) => {
        if (formType !== "VIEW") {
            const formErrors = allValidations(name, value, product);
            setProduct((prev) => ({ ...prev, [name]: value, formErrors }));
        }
    };

    const resetItemForm = () => {
        setProduct({
            _id: null,
            title: "",
            subTitle: "",
            ourWork: id,
            // description: "",
            image: "",
            url: "",
        });
    };

    const createProduct = () => {
        const productData = { ...product };
        if (Array.isArray(productData.image) && productData.image.length > 0) {
            productData.image = productData.image[0];
        }
        if (showFormErrors(productData, setProduct)) {
            if (product?._id) {
                dispatch(updateProduct(productData._id, productData, setShowAddProductDialog, resetItemForm));
            } else {
                dispatch(addProduct(productData, setShowAddProductDialog, resetItemForm));
            }
        }
    };

    const onDeleteProduct = (e, id, workId) => {
        confirmPopup({
            target: e.currentTarget,
            message:
                "Are you sure you want to delete this product? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteProduct(id, workId)),
            reject: () => { },
        });
    };

    return {
        dispatch,
        id,
        data,
        setData,
        handleChange,
        formType,
        setFormType,
        loading,
        addWork,
        history,
        HOST,
        setLoading,
        showAddProductDialog,
        setShowAddProductDialog,
        product,
        editProduct,
        createProduct,
        onDeleteProduct,
        handleProductChange,
    };
}
